export default __webpack_public_path__ + "static/media/login.21c77e59.png";